module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-onigiri@3x-c609ae6dd64961c75b161dd5784978ce.png";